/**
 * Import da biblioteca "styled-components", que permite escrever
 * CSS simples para os componentes sem acontecer conflitos com os
 * nomes das clases, são escritos entre Tagged Templates Literals(``).
 */
import styled from 'styled-components';

export const Groupbutton = styled.div`
  display: grid;
  grid-template-columns: 190px 1fr;

  .wrap-buttons{
    display: flex;
    justify-content: end;
    align-items: center;
    align-content: center;
    gap: 7px;
    margin-top: 6px;
  }
  
  button {
    padding: 0px;
    outline: none;
    margin-bottom: 0px;
  }

  button:hover {
    border-bottom: none;
  }
  
  button:disabled {
    color: #414c68;
    opacity: 0.5;
  }
`;

export const ModalContainer = styled.div`
position: relative;

.modal-int {
  position: absolute;
  background: #1F2D4D;
  width: 316px;
  min-height: 203px;
  padding: 2px 16px 0px 16px;
  border-radius: 5px;


  .wrap-title{
    display: flex;
    justify-content: space-between;
    align-items: center;
    align-content: center;
    border-bottom: 0.75px solid #ABABAB;

    color: #ABABAB;
    font-size: 14px;
    font-family: Roboto;
    font-weight: 300;
    margin-top: 8px;
    padding-bottom: 8px;

    svg{
      width: 12px;
      height: 16px;
      margin-top: 6px;
    }

    .close-modal{
      cursor: pointer;
    }
    
  }

  .form-group{
    display: flex;
    flex-direction: column;
    padding: 17px 12px 0px 12px;

    .MuiTextField-root {
      background: #FFFFFF;
      border: 0.5px solid rgba(0, 0, 0, 0.33);
      border-radius: 3px;
    }

    .MuiSelect-select {
      width: 130px;
      height: 16px;
      flex-shrink: 0; // para não diminuir o tamanho do select
      color: #5E5E5E;
      font-size: 14px;
      font-family: Roboto;

      .MuiMenuItem-root{
        font-size: 14px;
        border: 1px solid red;
      }
    }

    .MuiOutlinedInput-root:nth-child(1) {
      // width: 146px;
    }

    // .MuiOutlinedInput-root:nth-child(2) {
    //   width: 77.758px;
    // }

    .MuiOutlinedInput-root {
      border-radius: 4px;
      background-color: #fff;
      height: 40px;
      color: #ABABAB;
      font-size: 14px;
      font-family: Roboto;
      text-align: left;
  }

  .MuiMenu-list{
    font-size: 14px;
    border: 1px solid red !important;
    padding: 90px !important;
  }

    .Mui-disabled {
      color: #7A8295;
      opacity: 0.3;
    }

    .selects_grid {
      display: grid;
      grid-template-columns: calc(60% - 12px) calc(40% - 12px);
      grid-template-rows: 100%;
      column-gap: 18px;
      margin-bottom: 16px;


    }

    .coordinatesCreated{
      display: flex;
      gap: 17px;

      &.reverse {
        > div:last-child {
          // invertendo a ordem dos elementos
          order: -1;
        }
      }

      input#masked-input {
      background: #FFFFFF;
      width: 121.657px;
      height: 40px;
      flex-shrink: 0;
    }

     select:disabled {
      background: #414C68;  opacity: 0.6; /* Ajuste a opacidade conforme necessário */
      color: #7A8295;
  }

  }
}
`;
